$(document).ready(function() {
    $('.photo').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        }
    });

    $('.btn-iframe').magnificPopup({
        type: 'iframe',
        gallery: {
            enabled: false
        }
    });

    /* START menu for tablets and mobiles */
    $("#nav a.mobile-btn").click(function() {
        if($('#nav .nav').hasClass('active')){
            $('#nav .nav').removeClass('active');
            $(this).removeClass('active');
            $(this).find('i.icon').addClass('icon-menu').removeClass('icon-close');
        }else{
            $('#nav .nav').addClass('active');
            $(this).addClass('active');
            $(this).find('i.icon').removeClass('icon-menu').addClass('icon-close');
        }
    });
    /* END menu for tablets and mobiles*/


    $('.navbar a').click(function() {
        $('.'+$(this).attr('data-divs')).removeClass('active');
        $('#'+$(this).attr('data-target')).addClass('active');

        $(this).closest('ul').find('li').removeClass('active');

        $(this).parent('li').addClass('active');

    });

    $('.navbar2 a').click(function() {
        $('.'+$(this).attr('data-divs')).removeClass('active');
        $('#'+$(this).attr('data-target')).addClass('active');
        $('.navbar2 li').removeClass('active');

        $(this).parent('li').addClass('active');
    });

    $('#nav .nav a').click(function() {
        $('html, body').animate({
           scrollTop: $($(this).attr('data-target')).offset().top
        }, 2000);
    });

});
